import { ShopifyMediaType } from "@redotech/redo-prisma-client/enums";
import { imageIdFormat } from "@redotech/redo-product-id";
import { ShopifyIdType } from "@redotech/shopify-util/id";
import { shopifyGidSchema } from "@redotech/shopify-util/id-schema";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const ShopifyMediaContentTypeSchema = createEnum(ShopifyMediaType);

export const ShopifyMediaIdSchema = z.union([
  shopifyGidSchema(ShopifyIdType.MediaImage),
  shopifyGidSchema(ShopifyIdType.Video),
  shopifyGidSchema(ShopifyIdType.Model3D),
  shopifyGidSchema(ShopifyIdType.ExternalVideo),
] as const);
export type ShopifyMediaId = z.infer<typeof ShopifyMediaIdSchema>;

const ShopifyListingMediaSchema_ = z.object({
  shopifyId: ShopifyMediaIdSchema.nullable(),
  alt: z.string().nullable(),
  mediaContentType: ShopifyMediaContentTypeSchema,
  image: z.object({ url: z.string() }).nullable(),
  imageId: imageIdFormat.schema.nullish(),
});
export const ShopifyListingMediaSchema: z.ZodType<ShopifyListingMedia> =
  ShopifyListingMediaSchema_;
export interface ShopifyListingMedia extends z.infer<
  typeof ShopifyListingMediaSchema_
> {}

export type ShopifyListingMediaWithoutRedoIds = Omit<ShopifyListingMedia, "id">;

export type ShopifyListingMediaWithShopifyIds = Omit<
  ShopifyListingMedia,
  "shopifyId"
> & { shopifyId: string };
